export { default as PrimaryText } from "./PrimaryText";
export { default as SecondaryText } from "./SecondaryText";
export { default as BoldText } from "./BoldText";
export { default as Link } from "./Link";
export { default as LinkCta } from "./LinkCta";
export { default as SectionHeading } from "./SectionHeading";
export { default as StyledText } from "./StyledText";
export { default as Text } from "./Base";



// WEBPACK FOOTER //
// ./src/components/Text/index.js